export const turnScrollOn = (document) => {
    document.body.style.position = '';
    document.body.style.top = '';
    window.scrollTo(0, 0);
};

export const turnScrollOff = (document) => {
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
    document.body.style.top = '0px';
};
